export interface IAction {
  type: string;
}

export interface IActionWithParam<T> {
  type: string;
  param: T;
}

export interface IActionSuccess<T> {
  type: string;
  payload: T;
}

export interface IActionSuccessWithNoResult {
  type: string;
}

export interface IActionFailed {
  type: string;
  errorMessage: string;
}

export enum LoadingStates {
  FAILED = 'FAILED',
  NOT_STARTED = 'NOT_STARTED',
  STARTED = 'STARTED',
  SUCCEEDED = 'SUCCEEDED',
}

//Data model that can be used to deseralize the response of an ApiException
export interface ApiExceptionResponseBody {
  message: string;
  traceId: string;
  requestId: string;
  date: string;
  errorCode: string;
}
